import SuburbPestControlPage from "../components/SuburbPestControlPage";
import { IPSWICH_SUBURBS } from "../data/ipswichSuburbs";

export default function PestControlGoodnaPage() {
  return <SuburbPestControlPage suburb={IPSWICH_SUBURBS["goodna"]} />;
}
